/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadingcancelled2Inputs */

const en_menureadingcancelled2 = /** @type {(inputs: Menureadingcancelled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading cancelled – no credits were charged.`)
};

const de_menureadingcancelled2 = /** @type {(inputs: Menureadingcancelled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlesen abgebrochen – es wurden keine Credits abgebucht.`)
};

/**
* | output |
* | --- |
* | "Reading cancelled – no credits were charged." |
*
* @param {Menureadingcancelled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadingcancelled2 = /** @type {((inputs?: Menureadingcancelled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadingcancelled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadingcancelled2(inputs)
	return de_menureadingcancelled2(inputs)
});
export { menureadingcancelled2 as "menuReadingCancelled" }